import {Paper, Switch} from "@mantine/core";
import {LineChart} from "@mantine/charts";
import {useMemo, useState} from "react";
import {Col, Row} from "../../components/Flex/Flex";
import Icon from "../../components/Icon/Icon";
import IconMap from "../../components/Icon/IconMap";


const skill = [0,1,2,3,4,5];
const items = [
    {name: 'Kolto Patch', heal: 3, color: 'blue.6'},
    {name: 'Bacta Patch', heal: 5, color: 'teal.6'},
    {name: 'Healing Stick', heal: 8, color: 'orange.6'},
    {name: 'Medkit (Bacta Refill)', heal: 10, color: 'red.6'},
];

const series = items.map(({name, color}) => ({name, color}));


const calculateHP = (heal, skill, medbay) => {
    return Math.round(heal * (skill+1) * (medbay ? 1.3 : 1));
}
const calculateXP = (heal, skill, medbay) => {
    return Math.floor(calculateHP(heal, skill, medbay)/2);
}


export default function Medical () {
    const [medbay, setMedbay] = useState(false);

    const chartHP = useMemo(() => skill.map(s => {
        const row = {skill: s};
        items.forEach(item => { row[item.name] = calculateHP(item.heal, s, medbay); });
        return row;
    }), [medbay]);

    const chartXP = useMemo(() => skill.map(s => {
        const row = {skill: s};
        items.forEach(item => { row[item.name] = calculateXP(item.heal, s, medbay); });
        return row;
    }), [medbay]);

    return (
        <div className="w-full">
            <title>Medical Charts</title>
            <Row align="center">
                <Col><h1>Medical</h1></Col>
                <Col grow={1} />
                <Col><a className="link no-underline" href="https://www.swcombine.com/rules/?Medicine" target="_blank" rel="noreferrer"><Icon icon={IconMap.SwcRules} /> Full rules</a></Col>
            </Row>
            <Paper className="mb-3">
                <div className="float-right flex flex-row">
                    <label htmlFor="flipped" className="mr-1">MedBay</label>
                    <Switch id="flipped" checked={medbay} onChange={e => setMedbay(e.currentTarget.checked)}/>
                </div>
                <h2 className="mt-0">Healing</h2>
                <h3>HP</h3>
                <Row wrap={false} mobileCol={true}>
                    <Col basis="50%">
                        <table className="w-full">
                            <thead>
                            <tr>
                                <th/>
                                <th colSpan={skill.length + 1}>Medical Skill</th>
                            </tr>
                            <tr>
                                <th>Item</th>
                                {skill.map(s => <th key={s} className="text-right">{s}</th>)}
                            </tr>
                            </thead>
                            <tbody>
                            {items.map(item => (
                                <tr key={item.name}>
                                    <th className="text-left">{item.name}</th>
                                    {skill.map(s => <td key={s} className="text-right">{calculateHP(item.heal, s, medbay)}</td>)}
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </Col>
                    <Col basis="50%">
                        <LineChart h={300} data={chartHP} dataKey="skill" series={series} withLegend curveType="linear" />
                    </Col>
                </Row>
                <h3>XP</h3>
                <Row wrap={false} mobileCol={true}>
                    <Col basis="50%">
                        <table className="w-full">
                            <thead>
                            <tr>
                                <th/>
                                <th colSpan={skill.length + 1}>Medical Skill</th>
                            </tr>
                            <tr>
                                <th>Item</th>
                                {skill.map(s => <th key={s}  className="text-right">{s}</th>)}
                            </tr>
                            </thead>
                            <tbody>
                            {items.map(item => (
                                <tr key={item.name}>
                                    <th className="text-left">{item.name}</th>
                                    {skill.map(s => <td key={s} className="text-right">{calculateXP(item.heal, s, medbay)}</td>)}
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </Col>
                    <Col basis="50%">
                        <LineChart h={300} data={chartXP} dataKey="skill" series={series} withLegend curveType="linear" />
                    </Col>
                </Row>
            </Paper>
        </div>
    )


}
